import { IAggregationStructure } from '..';
import { Mechanic, PromoStatus } from '../../enums';
import { BusinessObject, CreateBusinessObject } from './business.interface';

// Category

export interface ICategory extends BusinessObject {
  name: string;
  label: string;
  unit?: string;
}

type ReadOnlyCategoryProperties = Pick<ICategory, 'name'>;
export type ICreateCategory = CreateBusinessObject<ICategory, ReadOnlyCategoryProperties>;

// Retailer

export interface IRetailer extends BusinessObject {
  name: string;
  label: string;
}

type ReadOnlyRetailerProperties = Pick<IRetailer, 'name'>;
export type ICreateRetailer = CreateBusinessObject<IRetailer, ReadOnlyRetailerProperties>;

// Segment

export interface ISegment extends BusinessObject {
  name: string;
  label: string;
  brandId: string | null;
  brand?: IAggregationStructure;
}

type ReadOnlySegmentProperties = Pick<ISegment, 'name'>;
export type ICreateSegment = CreateBusinessObject<ISegment, ReadOnlySegmentProperties>;

// Promotion Image

export interface IPromotionImage extends BusinessObject {
  idPromotion: string;
  url: string;
}

type ReadOnlyPromotionImageProperties = Pick<IPromotionImage, 'idPromotion'>;
export type ICreatePromotionImage = CreateBusinessObject<IRetailer, ReadOnlyPromotionImageProperties>;

export interface IImpactRoi {
  roi: number;
  retailer: string;
  brand: string;
  mechanic: Mechanic;
}

export enum CommentAction {
  Reconduire = 'A RECONDUIRE',
  Optimiser = 'A OPTIMISER',
  Stop = 'STOP'
}

export enum CommentUpgrade {
  Temporalité = 'Temporalité',
  Mécanique = 'Mécanique',
  Concurrence = 'Concurrence',
  StockClient = 'Stock client',
  Saisonnalité = 'Saisonnalité',
  Demande = 'Demande',
  MEA = 'MEA'
}
// Promotion

export interface IPromotion extends BusinessObject {
  idPromotion: string;
  idPromotionExport: string;
  ubId: string | null;
  ventesValeur: number | null;
  idPromoBrand: string;
  categoryId: string | null;
  category?: ICategory;
  categories?: string; // In case of aggregated promotion
  segmentId: string | null;
  segment?: ISegment;
  brandId: string | null;
  brandIds?: string[];
  brand?: IAggregationStructure;
  brands?: string; // In case of aggregated promotion
  retailerId: string | null;
  retailer?: IRetailer;
  description: string;
  promoType: string;
  mechanic: string;
  mecaSMP: string;
  generosity: number;
  status: PromoStatus;
  startDate: Date;
  endDate: Date;
  sellIn: number;
  sellInUnit?: number;
  sellUnit?: string;
  sellOutPromo: number;
  sellOutPromoEki: number;
  sellOutPromoEkiUnit?: number;
  profiteurRate: number;
  profiteurRateReel: number;
  destructionRate: number;
  nipCostPerOperation: number;
  nipCostPerOperationEki: number;
  xfgcXfpt: number;
  incrementalVolume: number;
  incrementalNns: number;
  incrementalCm: number;
  incrementalCmMinusCost: number;
  incrementalNnsMinusCost: number;
  totalRetenu: number;
  totalRSFRetenu: number;
  totalTradeRetenu: number;
  roi: number;
  ros: number;
  incrementalBrand: number;
  incrementalRetailer: number;
  incrementalRetailerVolume: number;
  evalType: string;
  image: IPromotionImage | null;
  rmeValidated: boolean;
  rmeValidatedBy: string;
  rmeValidatedAt: Date;
  rmeExported: boolean;
  rmeExportedAt: Date;
  validatedInSmartPromo: boolean;
  validatedInSmartPromoAt: Date;
  isValidatedAsConfirmed: boolean;
  sellOutTonnes: number;
  nnsEurKg: number;
  cmEurKg: number;
  bpYear: string;
  retainedPhase: string;
  grossPrice: number;
  nnsIncrementalSP: number;
  cmIncrementalSP: number;
  tonnesIncrSP: number;

  // PreEval related variables
  coefficient?: number;
  totalCost?: number;
  totalNIP?: number;
  incrementalRate?: number;
  destructionBrandMean?: number;
  newCoefficient: number | null;
  newTotalCost?: number | null;
  newIncrementalRate?: number | null;
  newDestructionBrandMean?: number | null;
  newProfiteurRateReel?: number | null;
  newMechanic?: string | null;
  newGenerosity?: number | null;
  context?: string[];
  yearPreEval: number;
  monthPreEval: number;

  comment?: string;
  commentAction?: CommentAction;
  commentUpgrade?: CommentUpgrade[];

  contextPromotions: string[];
}

type ReadOnlyProperties = Pick<IPromotion, 'idPromotion'>;
export type ICreatePromotion = CreateBusinessObject<IPromotion, ReadOnlyProperties>;
